import { taupunkt, absFeuchte, AH_MAX } from "../utils/psychro.js";

export class TaupunktWidget {
  constructor(root) {
    this.root = root;
    this.mode = "living";
    // Inputs binden
    this.root.querySelectorAll("[data-tp-input]").forEach(inp =>
      inp.addEventListener("input", () => this.update()));
    // Modus-Buttons binden
    this.root.querySelectorAll("[data-mode]").forEach(btn =>
      btn.addEventListener("click", () => {
        this.mode = btn.dataset.mode;
        this.root.querySelectorAll("[data-mode]").forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
        this.update();
      }));
    this.update(); // Initialzustand
  }
  q(sel) { return this.root.querySelector(sel); }
  val(name) { return parseFloat(this.q(`[data-tp-input='${name}']`).value); }
  update() {
    const tin = this.val("tin"), hin = this.val("hin");
    const tout = this.val("tout"), hout = this.val("hout");

    // Live-Werte an den Reglern
    this.q("[data-tp-val='tin']").textContent  = tin.toFixed(tin%1?1:0);
    this.q("[data-tp-val='hin']").textContent  = hin.toFixed(0);
    this.q("[data-tp-val='tout']").textContent = tout.toFixed(tout%1?1:0);
    this.q("[data-tp-val='hout']").textContent = hout.toFixed(0);

    // Taupunkte berechnen
    const tdIn  = taupunkt(tin, hin);
    const tdOut = taupunkt(tout, hout);
    this.q("[data-tp-td='in']").textContent  = tdIn.toFixed(1);
    this.q("[data-tp-td='out']").textContent = tdOut.toFixed(1);

    // Absolute Feuchte visualisieren (g/m³)
    const ahIn  = absFeuchte(tin, hin);
    const ahOut = absFeuchte(tout, hout);
    this.q("[data-tp-ah='in']").textContent  = ahIn.toFixed(1) + ' g/m³';
    this.q("[data-tp-ah='out']").textContent = ahOut.toFixed(1) + ' g/m³';
    this.q("[data-tp-ahfill='in']").style.width  = Math.min(ahIn/AH_MAX*100, 100).toFixed(0) + '%';
    this.q("[data-tp-ahfill='out']").style.width = Math.min(ahOut/AH_MAX*100, 100).toFixed(0) + '%';

    // --- Achse 1: Feuchte (Taupunktdifferenz innen - außen) ---
    const delta = tdIn - tdOut;
    this.q("[data-tp-delta]").textContent = (delta>=0?'+':'') + delta.toFixed(1);

    // --- Achse 2: Temperatur (modusabhängige Schwellen) ---
    const dT = tin - tout;                 // >0 = außen kühler
    this.q("[data-tp-dtemp]").textContent = (dT>=0?'+':'') + dT.toFixed(dT%1?1:0);

    // Komfort-/Dringend-Schwellen je Raumnutzung
    // Wohnen tags: Kühlwunsch ab 24 °C (Komfort bis 23), dringend ab 26 (Orientierung angelehnt an ASR A3.5, Arbeitsstätten)
    // Schlafen nachts: Bedürfnis ab 19-20 °C, dringend ab 21
    const TH = {
      living: { comfort: 24, urgent: 26 },
      sleep:  { comfort: 19, urgent: 21 }
    };
    const th = TH[this.mode];
    const warmInside = tin >= th.comfort;      // innen über Komfortschwelle
    const coolChance = warmInside && dT >= 3;  // außen spürbar kühler → Kühlen möglich
    const urgent     = tin >= th.urgent && dT >= 3;  // über Normgrenze + kühler → dringend

    // Feuchte-Basisurteil
    let humid;                             // 'out' entfeuchtet | 'in' feuchter | 'flat' egal
    if(delta > 0.5)      humid = 'out';
    else if(delta < -0.5) humid = 'in';
    else                  humid = 'flat';

    // --- Kombinierte Empfehlung ---
    const v = this.q("[data-tp-verdict]");
    let state, call, why;

    if(coolChance && humid === 'in'){      // der realistische Zielkonflikt
      state = 'conflict';
      call  = urgent ? 'Kühlen geht vor' : 'Zielkonflikt';
      why = 'Feuchte-technisch Fenster zu — aber bei ' + tin.toFixed(0) + '\u00A0°C innen / '
          + tout.toFixed(0) + '\u00A0°C außen ' + (urgent ? 'ist die Behaglichkeitsgrenze überschritten: kühlen hat Vorrang.' : 'gewinnt meist das Kühlen.')
          + ' Kurz lüften kühlt, holt aber etwas Feuchte rein.';
    } else if(humid === 'out'){
      state = 'open'; call = 'Fenster auf';
      why = 'Außenluft ist trockener — Lüften transportiert Feuchte raus'
          + (urgent ? ' und kühlt dringend nötig herunter.' : (coolChance ? ' und kühlt zusätzlich.' : '.'));
    } else if(humid === 'in'){
      state = 'closed'; call = 'Fenster zu';
      why = 'Draußen ist mehr Wasser in der Luft — Lüften macht den Raum feuchter.';
    } else {                               // Feuchte egal → Temperatur entscheidet
      if(coolChance){
        state = 'open'; call = urgent ? 'Dringend lüften' : 'Fenster auf';
        why = 'Feuchte fast gleich — aber außen ist kühler, Lüften kühlt den Raum'
            + (urgent ? ' (Behaglichkeitsgrenze überschritten).' : '.');
      } else {
        state = 'open'; call = 'Grenzfall';
        why = 'Kaum Unterschied bei Feuchte und Temperatur — andere Faktoren (CO₂, Wärmelast) entscheiden.';
      }
    }

    v.dataset.state = state;
    this.q("[data-tp-call]").textContent = call;
    this.q("[data-tp-why]").textContent  = why;
  }
}
